// Recovered compiled webpack factory 49417. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  function n(e) {
    if ("function" != typeof WeakMap) return null;
    var t = new WeakMap(),
      r = new WeakMap();
    return (n = function (e) {
      return e ? r : t;
    })(e);
  }
  function a(e, t) {
    if (!t && e && e.__esModule) return e;
    if (null === e || ("object" != typeof e && "function" != typeof e)) return { default: e };
    var r = n(t);
    if (r && r.has(e)) return r.get(e);
    var a = { __proto__: null },
      o = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var i in e)
      if ("default" !== i && Object.prototype.hasOwnProperty.call(e, i)) {
        var s = o ? Object.getOwnPropertyDescriptor(e, i) : null;
        s && (s.get || s.set) ? Object.defineProperty(a, i, s) : (a[i] = e[i]);
      }
    return ((a.default = e), r && r.set(e, a), a);
  }
  (r.r(t), r.d(t, { _: () => a }));
}
